var $247f3ad62bbc212e$exports = {};
$247f3ad62bbc212e$exports = {
    "replaceMessage": `Suelte el archivo para reemplazar`
};


export {$247f3ad62bbc212e$exports as default};
//# sourceMappingURL=es-ES.mjs.map
